export default __webpack_public_path__ + "static/media/thum2.a901dfce.jpg";